import { OrderChannel } from "../../components/constants/OrderChannel";

// Plan constants
export const PLAN_ESSENTIAL = "essential";
export const PLAN_STANDARD = "standard";
export const PLAN_PRO_KITCHEN = "pro_kitchen";
export const PLAN_ELITE_KITCHEN = "elite_kitchen";

// Plan display names mapping
export const PLAN_DISPLAY_NAMES: { [key: string]: string } = {
  [PLAN_ESSENTIAL]: "Essential (Free Forever)",
  [PLAN_STANDARD]: "Standard",
  [PLAN_PRO_KITCHEN]: "Pro Kitchen",
  [PLAN_ELITE_KITCHEN]: "Elite Kitchen",
};

// Plan prices mapping (in USD per month)
export const PLAN_PRICES: { [key: string]: number } = {
  [PLAN_ESSENTIAL]: 0,
  [PLAN_STANDARD]: 59,
  [PLAN_PRO_KITCHEN]: 79,
  [PLAN_ELITE_KITCHEN]: 169,
};

// Plan features matrix - which services each plan includes
const PLAN_FEATURES: { [key: string]: OrderChannel[] } = {
  [PLAN_ESSENTIAL]: [OrderChannel.COUNTER],
  [PLAN_STANDARD]: [
    OrderChannel.COUNTER,
    OrderChannel.TABLE,
    OrderChannel.TAKEAWAY,
  ],
  [PLAN_PRO_KITCHEN]: [
    OrderChannel.COUNTER,
    OrderChannel.TABLE,
    OrderChannel.TAKEAWAY,
    OrderChannel.DELIVERY,
  ],
  [PLAN_ELITE_KITCHEN]: [
    OrderChannel.COUNTER,
    OrderChannel.TABLE,
    OrderChannel.TAKEAWAY,
    OrderChannel.DELIVERY,
    OrderChannel.ONLINE,
  ],
};

// KDS availability - which plans include KDS
const KDS_PLANS = [PLAN_PRO_KITCHEN, PLAN_ELITE_KITCHEN];

export const getPlanFeatures = (plan: string | undefined): OrderChannel[] => {
  if (!plan) {
    return PLAN_FEATURES[PLAN_ESSENTIAL];
  }
  return PLAN_FEATURES[plan] || PLAN_FEATURES[PLAN_ESSENTIAL];
};

export const canAccessService = (
  plan: string | undefined,
  service: OrderChannel
): boolean => {
  const features = getPlanFeatures(plan);
  return features.includes(service);
};

export const getOrderLimit = (plan: string | undefined): number | null => {
  if (!plan || plan === PLAN_ESSENTIAL) {
    return 100;
  }
  return null;
};

export const isUnlimitedOrders = (plan: string | undefined): boolean => {
  return getOrderLimit(plan) === null;
};

export const getPlanDisplayName = (plan: string | undefined): string => {
  if (!plan) {
    return PLAN_DISPLAY_NAMES[PLAN_ESSENTIAL];
  }
  return PLAN_DISPLAY_NAMES[plan] || plan;
};

export const getPlanPrice = (plan: string | undefined): number => {
  if (!plan) {
    return PLAN_PRICES[PLAN_ESSENTIAL];
  }
  return PLAN_PRICES[plan] || 0;
};

export const getAllPlans = (): string[] => {
  return [PLAN_ESSENTIAL, PLAN_STANDARD, PLAN_PRO_KITCHEN, PLAN_ELITE_KITCHEN];
};

export const supportsReservations = (plan: string | undefined): boolean => {
  if (!plan) return false;
  return (
    plan === PLAN_STANDARD ||
    plan === PLAN_PRO_KITCHEN ||
    plan === PLAN_ELITE_KITCHEN
  );
};

export const supportsDelivery = (plan: string | undefined): boolean => {
  if (!plan) return false;
  return plan === PLAN_PRO_KITCHEN || plan === PLAN_ELITE_KITCHEN;
};

export const supportsOnlineOrders = (plan: string | undefined): boolean => {
  if (!plan) return false;
  return plan === PLAN_ELITE_KITCHEN;
};

export function supportsKDS(plan: string | undefined): boolean {
  if (!plan) return false;
  return KDS_PLANS.includes(plan);
}

